import { render, staticRenderFns } from "./ChangeCredits.vue?vue&type=template&id=d8463fce&scoped=true"
import script from "./ChangeCredits.vue?vue&type=script&lang=js"
export * from "./ChangeCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8463fce",
  null
  
)

export default component.exports